import React from 'react'
import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import AppLayout from '../AppLayout';


import FranchiseeUserDashboard from '../franchisee_user/FranchiseeUserDashboard';
import FranchiseeUserSidebar from '../sidebars/FrachiseeUserSidebar';
import UsersPage from '../franchisee_user/users/UsersPage';
import NewUserPage from '../franchisee_user/users/NewUserPage';
import EditUserPage from '../franchisee_user/users/EditUserPage';
import EditHoaPage from '../franchisee_user/hoas/EditHoaPage';
import NewHoaPage from '../franchisee_user/hoas/NewHoaPage';
import HoasPage from '../franchisee_user/hoas/HoasPage';
import UomsPage from '../franchisee_user/uoms/UomsPage';
import NewUomPage from '../franchisee_user/uoms/NewUomPage';
import EditUomPage from '../franchisee_user/uoms/EditUomPage';
import PartygroupsPage from '../franchisee_user/partygroups/PartygroupsPage';
import NewPartygroupPage from '../franchisee_user/partygroups/NewPartygroupPage';
import EditPartygroupPage from '../franchisee_user/partygroups/EditPartygroupPage';
import PartiesPage from '../franchisee_user/parties/PartiesPage';
import NewPartyPage from '../franchisee_user/parties/NewPartyPage';
import EditPartyPage from '../franchisee_user/parties/EditPartyPage';
import ProductsPage from '../franchisee_user/products/ProductsPage';
import NewProductPage from '../franchisee_user/products/NewProductPage';
import EditProductPage from '../franchisee_user/products/EditProductPage';
import RateTypesPage from '../franchisee_user/rate_types/RateTypesPage';
import NewRateTypePage from '../franchisee_user/rate_types/NewRateTypePage';
import EditRateTypePage from '../franchisee_user/rate_types/EditRateTypePage';
import NewRatePage from '../franchisee_user/rates/NewRatePage';
import EditRatePage from '../franchisee_user/rates/EditRatePage';
import RatesPage from '../franchisee_user/rates/RatesPage';
import PurchaseInvoicesPage from '../franchisee_user/purchase_invoices/PurchaseInvoicesPage';
import NewPurchaseInvoicePage from '../franchisee_user/purchase_invoices/NewPurchaseInvoicePage';
import EditPurchaseInvoicePage from '../franchisee_user/purchase_invoices/EditPurchaseInvoicePage';
import GrnPage from '../franchisee_user/grn/GrnPage';
import NewGrnPage from '../franchisee_user/grn/NewGrnPage';
import EditGrnPage from '../franchisee_user/grn/EditGrnPage';
import OpeningBalancesManagerPage from '../franchisee_user/opening_balances/OpeningBalancesManagerPage';
import SalesInvoicesPage from '../franchisee_user/sales-invoices/SalesInvoicesPage';
import NewSalesInvoicePage from '../franchisee_user/sales-invoices/NewSalesInvoicePage';
import EditSalesInvoicePage from '../franchisee_user/sales-invoices/EditSalesInvoicePage';
import StockView from '../franchisee_user/stocks-view/StockView';
import StockLooseningForm from '../franchisee_user/product-loosening/StockConversionsPage';
import StockConversionsPage from '../franchisee_user/product-loosening/StockConversionsPage';
import EditStockConversionPage from '../franchisee_user/product-loosening/EditStockConversionPage';
import NewStockConversionPage from '../franchisee_user/product-loosening/NewStockConversionPage';
import PurchaseReturnsPage from '../franchisee_user/purchase-returns/PurchaseReturnsPage';
import NewPurchaseReturnPage from '../franchisee_user/purchase-returns/NewPurchaseReturnPage';
import EditPurchaseReturnPage from '../franchisee_user/purchase-returns/EditPurchaseReturnPage';
import NewVoucherPage from '../franchisee_user/vouchers/NewVoucherPage';
import VouchersPage from '../franchisee_user/vouchers/VouchersPage';
import EditVoucherPage from '../franchisee_user/vouchers/EditVoucherPage';
import SalesReturnForm from '../franchisee_user/sales_return_notes/SalesReturnForm';
import SalesReturnsPage from '../franchisee_user/sales_return_notes/SalesReturnsPage';
import NewSalesReturnPage from '../franchisee_user/sales_return_notes/NewSalesReturnPage';
import EditSalesReturnPage from '../franchisee_user/sales_return_notes/EditSalesReturnPage';
import CreditNotesPage from '../franchisee_user/credit_notes/CreditNotesPage';
import NewCreditNotePage from '../franchisee_user/credit_notes/NewCreditNotePage';
import EditCreditNotePage from '../franchisee_user/credit_notes/EditCreditNotePage';
import DebitNotesPage from '../franchisee_user/debit_notes/DebitNotesPage';
import NewDebitNotePage from '../franchisee_user/debit_notes/NewDebitNotePage';
import EditDebitNotePage from '../franchisee_user/debit_notes/EditDebitNotePage';
import GenericReportsPage from '../franchisee_user/reports/GenericReportsPage';
import FranchiseeSettingsPage from '../franchisee_user/settings/FranchiseeSettingsPage';


const FranchiseeUserRoutes = () => {
  return (
    <Routes>

        
     

     


  
      <Route
        exact path="/home"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <FranchiseeUserDashboard />
            </AppLayout>
          </RequireAuth>
        }
      />
     

      <Route
        path="/users"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <UsersPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/users/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewUserPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/users/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditUserPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/masters/hoas"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <HoasPage />
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/masters/hoas/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewHoaPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/masters/hoas/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditHoaPage/>
            </AppLayout>
          </RequireAuth>
        }
      />   
      <Route
        path="/masters/uoms"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <UomsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/masters/uoms/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewUomPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/masters/uoms/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditUomPage/>
            </AppLayout>
          </RequireAuth>
        }
      />


 <Route
        path="/masters/partygroups"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <PartygroupsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/masters/partygroups/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewPartygroupPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/masters/partygroups/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditPartygroupPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

 <Route
        path="/masters/parties"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <PartiesPage />
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/masters/parties/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewPartyPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/masters/parties/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditPartyPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

<Route
        path="/masters/products"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <ProductsPage/>
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/masters/products/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewProductPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/masters/products/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditProductPage/>
            </AppLayout>
          </RequireAuth>
        }
      />


      <Route
        path="/masters/rate-types"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <RateTypesPage/>
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/masters/rate-types/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewRateTypePage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/masters/rate-types/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditRateTypePage/>
            </AppLayout>
          </RequireAuth>
        }
      />
      
 <Route
        path="/masters/rates"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <RatesPage/>
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/masters/rates/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewRatePage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/masters/rates/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditRatePage/>
            </AppLayout>
          </RequireAuth>
        }
      />


<Route
        path="/inventory/purchase-invoices"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <PurchaseInvoicesPage/>
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/inventory/purchase-invoices/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewPurchaseInvoicePage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/inventory/purchase-invoices/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditPurchaseInvoicePage/>
            </AppLayout>
          </RequireAuth>
        }
      />


<Route
        path="/inventory/grn"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <GrnPage/>
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/inventory/grn/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewGrnPage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/inventory/grn/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditGrnPage/>
            </AppLayout>
          </RequireAuth>
        }
      />


  <Route
        path="/inventory/opening-balances"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <OpeningBalancesManagerPage/>
            </AppLayout>
          </RequireAuth>
        }
      />




<Route
        path="/sales/sales-invoices"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <SalesInvoicesPage/>
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/sales/sales-invoices/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewSalesInvoicePage/>
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/sales/sales-invoices/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditSalesInvoicePage/>
            </AppLayout>
          </RequireAuth>
        }
      />
      
        <Route
        path="/sales/sales-invoices/view/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditSalesInvoicePage/>
            </AppLayout>
          </RequireAuth>
        }
      />



      <Route
        path="/sales/sales-returns"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <SalesReturnsPage/>
            </AppLayout>
          </RequireAuth>
        }
      />
       <Route
        path="/sales/sales-returns/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewSalesReturnPage/>
            </AppLayout>
          </RequireAuth>
        }
      />


          <Route
        path="/sales/sales-returns/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditSalesReturnPage/>
            </AppLayout>
          </RequireAuth>
        }
      />


      {/* --- 2. ADD THE NEW ROUTE FOR STOCK VIEW --- */}
  <Route
        path="/inventory/stock-view"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <StockView />
            </AppLayout>
          </RequireAuth>
        }
      />
  {/* ------------------------------------------- */}


{/* ** 2. ADD THE NEW ROUTES FOR STOCK LOOSENING (CRUD) ** */}
    <Route
        path="/inventory/stock-conversions"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <StockConversionsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/inventory/stock-conversions/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewStockConversionPage />

            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/inventory/stock-conversions/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditStockConversionPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    {/* -------------------------------------------------- */}


    {/* ** 2. ADD THE NEW ROUTES FOR PURCHASE RETURNS (CRUD) ** */}
    <Route
        path="/inventory/purchase-returns"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <PurchaseReturnsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/inventory/purchase-returns/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewPurchaseReturnPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/inventory/purchase-returns/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditPurchaseReturnPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    {/* -------------------------------------------------- */}



        {/* ** 2. ADD THE NEW ROUTES FOR PURCHASE RETURNS (CRUD) ** */}
    <Route
        path="/sales/credit-notes"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <CreditNotesPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/sales/credit-notes/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewCreditNotePage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/sales/credit-notes/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditCreditNotePage />
            </AppLayout>
          </RequireAuth>
        }
      />
    {/* -------------------------------------------------- */}


        {/* ** 2. ADD THE NEW ROUTES FOR PURCHASE RETURNS (CRUD) ** */}
    <Route
        path="/sales/debit-notes"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <DebitNotesPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/sales/debit-notes/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewDebitNotePage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/sales/debit-notes/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditDebitNotePage />
            </AppLayout>
          </RequireAuth>
        }
      />
    {/* -------------------------------------------------- */}


      {/* ** 2. ADD THE NEW ROUTES FOR PURCHASE RETURNS (CRUD) ** */}
    <Route
        path="/finance/vouchers"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <VouchersPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/finance/vouchers/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <NewVoucherPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    <Route
        path="/finance/vouchers/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <EditVoucherPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    {/* -------------------------------------------------- */}

 <Route
        path="/reports/sales"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <GenericReportsPage moduleTitle="Sales" module="sales" />
            </AppLayout>
          </RequireAuth>
        }
      /> 
      
      <Route
        path="/reports/inventory"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <GenericReportsPage moduleTitle="Inventory" module="inventory" />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/reports/finance"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <GenericReportsPage moduleTitle="Finance" module="finance" />
            </AppLayout>
          </RequireAuth>
        }
      />
      
       <Route
        path="/franchisee_settings"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <FranchiseeSettingsPage />
            </AppLayout>
          </RequireAuth>
        }
      />
    
       
    </Routes>
  )
}

export default FranchiseeUserRoutes
